import React, { Component } from 'react'
import './Bio.css'

import Res from '../values/Resources'

import CustomLink from './CustomLink'

export default class Bio extends Component {

	render() {
		return (
			<div className='bio'>
				<div className='header'>
					<div className='background'/>
					<div className='content'>
						<h1>
							{Res.strings.bio_title.t1}<br/>
							{Res.strings.bio_title.t2}<br/>
							{Res.strings.bio_title.t3}
						</h1>
					</div>
				</div>
				<div className='paragraph'>
					<p>
						{Res.strings.bio_info_p1}<br/><br/>
						{Res.strings.bio_info_p2}<br/><br/>
						{Res.strings.bio_info_p3}<br/><br/>
						{Res.strings.bio_info_p4}<br/><br/>
					</p>
				</div>
				<CustomLink
				  link={`mailto:${Res.strings.menu_contact_email}`}
				  title={Res.strings.bio_action}/>
			</div>
		) // <h1>{Res.strings.bio_action}</h1>
	}
}


// WEBPACK FOOTER //
// ./src/components/Bio.js